import React, { useState, useEffect, useRef } from "react";
import moment from "moment-timezone";
import { OpenAuctionWithApplications } from "./OpenAuctionWithApplications"
import { GetLotInfoPromise } from "./remote";
import { BaseLotInfoByUser } from "../../../Models/Lots/BaseLotInfoByUser"
import { PaymentStatus } from "../../../enums/PaymentStatus"
import { PaymentType } from "../../../enums/PaymentType"
import { TradeStatus } from "../../../enums/TradeStatus"
import { ApplicationStatus } from "../../../enums/ApplicationStatus"
import DepositLot from "../baseComponent/DepositLot"
import MakeBet from "../baseComponent/MakeBet"
import Tabs from "../baseComponent/tabs/tabs"
import { Menu } from "primereact/menu";
import AboutLotTab from "../baseComponent/tabs/AboutLotTab"
import AboutSellerTab from "../baseComponent/tabs/AboutSellerTab"
import { ApplicationDetails } from "../../../TradeApplication/components/ApplicationDetails";
import AccountInfo from "../../../Profile/AccountInfo"
import Timer from "../../../Ui/Timer/Timer";

interface IPropsType {
    lotId: number;
}

export class OpenAuctionWithApplicationsReadOnly extends OpenAuctionWithApplications {
    constructor(props: IPropsType) {
        super(props);
        console.log(props);

        this.state = {
            Lot: null,
            lotId: props.lotId
        }

    }

    getAuctionData() {
        GetLotInfoPromise(this.state.lotId).then((result) => {
            console.log(result);
            var paymentByDeposit = this.getPayment(result.Payments, PaymentType.PaymentOfDeposit);

            if (paymentByDeposit == null)
                result.DepositStatus = PaymentStatus.PaymentNotReceived;
            else
                result.DepositStatus = paymentByDeposit.StatusId;

            this.setState({ ...this.state, Lot: result });
            this.init(this.state);
            console.log('получили состояние', this.state);
        });
    }

    render() {
        console.log('this.state.Lot=', this.state.Lot);
        if (this.state.Lot == null) {
            this.getAuctionData();
            return (<div>Загружаю данные...</div>);
        }
        else if (this.state.Lot.Error != null) {
            return (<div>{this.state.Lot.Error}</div>);
        }
        else { 
            return (
                <div className="lotPage">
                    <div className="lotHead">
                        <h1>{this.state.Lot.Name}
                            {AccountInfo.CompanyId == undefined &&
                                <p className="errorText">Для участия в данном торге необходимо авторизоваться или зарегистрироваться.</p>
                            }                   
                                <img src="../../../../../../main-images/needCert.jpg"/>
                            <span>к/н {this.getCadastrNumber(this.state.Lot.Filters)}</span>
                        </h1>
                        <div className="middle">
                            {this.getGallery(this.props.lotId, this.state.Lot.Pictures, this.state.Lot.IsHasFavorites)}
                            <div className="lotActionMenu">
                                <div className="title">
                                    <h4>{this.state.Lot.CurrentPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}₽</h4>
                                    <span>Текущая цена</span>
                                    { /* краткая информация по лоту */}
                                    <div className="shortInfo">

                                        {this.ShortInfoLot(this.state.Lot)}
                                        {this.ShowFailedTradeReason()}

                                        <div className="infoItem">
                                            <span>Размер задатка:</span>
                                            <h5>{this.state.Lot?.DepositSize || this.state.Lot.BasePrice * (this.state.Lot?.DepositPercent / 100)}₽
                                                {this.state.Lot?.DepositDate &&
                                                    <p className="defaultDescription">Дата до которой необходимо внести задаток: {moment(this.state.Lot?.DepositDate).format("DD.MM.YYYY")}</p>}
                                            </h5>
                                        </div>
                                    </div>

                                    {this.state.Lot.LotTradeStatusId == TradeStatus.Trading &&
                                        AccountInfo?.IsAdminRole && <div className="infoItem">
                                            <span>Время до конца торга</span>
                                            <Timer
                                                startTime={
                                                    this.state.Lot.Bets?.length > 0
                                                        ? this.state.Lot.Bets.reduce((latest, bet) =>
                                                            new Date(bet.StartPriceDate) > new Date(latest.StartPriceDate) ? bet : latest
                                                        ).StartPriceDate
                                                        : this.state.Lot.LotTradePeriodStart
                                                }
                                                duration={this.state.Lot.LengthForTimer}
                                                onTimerFinished={() => this.FinishTrade()}
                                                isProcessing={this.state.isFinishingTrade}
                                            />
                                        </div>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lotDetails">
                        {/* вкладки */}
                        <Tabs menu={this.MenuTabs()} />
                    </div>
                </div>
            );
        }
    }
}